import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { SavedCourseComponent } from './saved-course/saved-course.component';
import { CompletedCourseComponent } from './completed-course/completed-course.component';
import { InProgressCourseComponent } from './in-progress-course/in-progress-course.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  // public courseListLength = 0;
  // public bookmarkListSize = 0;
  // public inprogressListSize = 0;
  // public completedListSize = 0;

  constructor(private userService: UserService,
    public router: Router) {
  }

  ngOnInit() {
  
  }

  // private getUserCourse() {
  //   const userId = localStorage.userObject ? JSON.parse(localStorage.userObject) : null;
  //   this.userService.getusercourse(userId, 0, 'all')
  //     .subscribe(
  //       (response: any[]) => {
  //         // To set the number based on the course status.
  //         this.bookmarkListSize = this.getBookmarkListLength(response);
  //         this.inprogressListSize = this.getInprogressListLength(response);
  //         this.completedListSize = this.getCompletedListLength(response);
  //       }
  //     );
  // }

  // private getBookmarkListLength(response: any[]) {
  //   return response.filter(ele => ele.isBookMarked).length;
  // }

  // private getInprogressListLength(response: any[]) {
  //   return response.filter(ele => ele.analytic.categoryCompletedPercentage < 100).length;
  // }

  // private getCompletedListLength(response: any[]) {
  //   return response.filter(ele => ele.analytic.categoryCompletedPercentage === 100).length;
  // }

  // public setCourselistLength(length): number {
  //   return length ? this.courseListLength = length : this.courseListLength = 0;
  // }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user.component.ts